import { RootState } from 'src/reducers/rootReducer';
export interface OverlayViewState {
  activeUri: string;
  inspector_history: string[];
}
const initialItemState: OverlayViewState = {
  activeUri: '',
  inspector_history: [],
};
export enum OverlayViewActions {
  OPEN_VIEW = 'OPEN_VIEW',
  CLOSE_VIEW = 'CLOSE_VIEW',
}

export const overlayViews = (state: { [key: string]: any } = {}, action: any) => {
  const currentUri = action?.configUri?.lastSplitValue();
  const updatedStateAfterClose = (viewState: any, action: any) => {
    if (action.uri) {
      const inspectorHistory = viewState.inspector_history;
      const searchedIndex = inspectorHistory.indexOf(action.uri);
      inspectorHistory.splice(searchedIndex, 1);
      if (searchedIndex > 0) {
        return {
          ...viewState,
          activeUri: inspectorHistory[searchedIndex - 1],
          inspector_history: inspectorHistory,
        };
      }
      return {
        ...viewState,
        activeUri: '',
        inspector_history: [],
      };
    }
  };
  const updatedStateAfterOpen = (viewState: any, action: any) => {
    const uri = action.uri;
    const inspectorHistory = viewState.inspector_history;
    if (inspectorHistory.indexOf(uri) === -1) {
      inspectorHistory.push(uri);
    }
    return {
      ...viewState,
      activeUri: uri,
      inspector_history: inspectorHistory,
    };
  };

  switch (action.type) {
    case OverlayViewActions.OPEN_VIEW: {
      if (!state[currentUri]) {
        state[currentUri] = {
          activeUri: '',
          inspector_history: [],
        };
      }
      return {
        ...state,
        [currentUri]: updatedStateAfterOpen(state[currentUri], action),
      };
    }
    case OverlayViewActions.CLOSE_VIEW: {
      return {
        ...state,
        [currentUri]: updatedStateAfterClose(state[currentUri], action),
      };
    }
    default:
      return state;
  }
};

export const overlayViewsSelector = (state: RootState, configUri: string) =>
  state.overlayViews[`${configUri.lastSplitValue()}`] || initialItemState;
